import React, { Component } from 'react';
import AssessmentEvidenceSwitch from '../../../../components/AssessmentEvidenceSwitch';
import IBSLAssessment from './IBSLAssessment';
import SignatureEvidence from './SignatureEvidence';

class AssessmentAndEvidences extends Component {
  constructor (props) {
    super(props);
    this.typeClickHandler = this.typeClickHandler.bind(this);
    this.state = {
      switchType: 'ibsl'
    };
  }
  typeClickHandler (switchType) {
    this.setState(
      {
        switchType: switchType
      }
    );
  }
  render () {
    let pageToRender = <IBSLAssessment />;
    if (this.state.switchType === 'signature') {
      pageToRender = <SignatureEvidence />;
    }
    return (
      <span>
        <h1 className='u-text-center'>Assessment & NVQ evidences</h1>
        <div className='l-container l-container--x-narrow'>
          <AssessmentEvidenceSwitch switchType={this.state.switchType} handleTypeClick={this.typeClickHandler} />
          {pageToRender}
        </div>
      </span>
    );
  }
}

export default AssessmentAndEvidences;



// WEBPACK FOOTER //
// ./src/views/Main/Tour/AssessmentAndEvidences/index.js